import { IListItem, IMicrositeRecipientForList } from "@nkr/models/index";
import { Row, Col, Panel, PanelGroup, Table, Button, Glyphicon, Form, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import * as moment from 'moment';
import { IMicrositeEventLog } from "@nkr/models/microsites";
import { useState } from "react";
import { MicrositeEventType, transplantEventTypes } from "@nkr/enums/microsite-event-type";

interface IProps {
    recipient: IMicrositeRecipientForList,
    eventTypeList: IListItem[],
    onTxpEdit: (eventId: number) => void
}

const EventHistoryAccordion = ({ recipient, eventTypeList, onTxpEdit }: IProps) => {
    const [editingEvent, setEditingEvent] = useState<IMicrositeEventLog | null>(null);
    const [editedEvent, setEditedEvent] = useState<IMicrositeEventLog | null>(null);

    const handleEditCancel = () => {
        setEditingEvent(null);
        setEditedEvent(null);
    };

    const handleEditSave = () => {
        if (editedEvent) {
            setEditingEvent(null);
            setEditedEvent(null);
        }
    };

    const handleTypeChange = (e) => {
        if (editedEvent) {
            setEditedEvent({
                ...editedEvent,
                eventType: e.target.value
            });
        }
    };

    const handleDateChange = (e) => {
        if (editedEvent) {
            setEditedEvent({
                ...editedEvent,
                eventDate: e.target.value
            });
        }
    };

    const handleCommentChange = (e) => {
        if (editedEvent) {
            setEditedEvent({
                ...editedEvent,
                comment: e.target.value
            });
        }
    };

    const trs = recipient?.micrositeEventLogs.sort((a: IMicrositeEventLog, b: IMicrositeEventLog) => {  //sort desc by id
        return b.id - a.id;
    }).map((l, i) => {

        let isTransplantType = transplantEventTypes.includes(l.eventType);
            
        return (
            <tr key={i}>
                <td>{i + 1}</td>
                <td>{moment(l.eventDate).format('MM/DD/YYYY')}</td>
                <td>{eventTypeList.find(f => f.id == l.eventType)?.description}</td>
                <td>{l.comment}</td>
                <td><span style={{whiteSpace:'nowrap'}}>{moment(l.eventRecordedDateTime).format('MM/DD/YYYY')}</span></td>
                <td>
                    {isTransplantType
                        && <Button bsStyle='link' bsSize='sm' onClick={() => onTxpEdit(l.id)}><Glyphicon glyph='pencil' /></Button>
                    }
                    
                </td>
            </tr>
        );
    });

    return (
        <Panel id="collapsible-panel-example-2" defaultExpanded>
            <Panel.Heading>
                <Panel.Title toggle>
                    Event History
                </Panel.Title>
            </Panel.Heading>
            <Panel.Collapse>
                <Panel.Body>
                    <Row>
                        <Col sm={12}>
                            <Table striped bordered condensed hover>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Event Date</th>
                                        <th>Event</th>
                                        <th>Comment</th>
                                        <th>Log Date</th>
                                        <th>Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {trs}
                                    {trs?.length === 0 && <tr><td colSpan={99} style={{ textAlign: 'center' }}>There is no history to display.</td></tr>}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {editingEvent && (
                        <Row>
                            <Col sm={12}>
                                <div className="edit-event-container" style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '4px', marginTop: '15px' }}>
                                    <h4>Edit Event</h4>
                                    <Form horizontal>
                                        <FormGroup controlId="eventType">
                                            <Col componentClass={ControlLabel} sm={2}>
                                                Event Type
                                            </Col>
                                            <Col sm={10}>
                                                <FormControl 
                                                    componentClass="select" 
                                                    value={editedEvent?.eventType} 
                                                    onChange={handleTypeChange}
                                                >
                                                    {eventTypeList.map(type => (
                                                        <option key={type.id} value={type.id}>{type.description}</option>
                                                    ))}
                                                </FormControl>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup controlId="eventDate">
                                            <Col componentClass={ControlLabel} sm={2}>
                                                Date
                                            </Col>
                                            <Col sm={10}>
                                                <FormControl 
                                                    type="date" 
                                                    value={moment(editedEvent?.eventDate).format('YYYY-MM-DD')} 
                                                    onChange={handleDateChange}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup controlId="eventComment">
                                            <Col componentClass={ControlLabel} sm={2}>
                                                Comment
                                            </Col>
                                            <Col sm={10}>
                                                <FormControl 
                                                    componentClass="textarea" 
                                                    value={editedEvent?.comment} 
                                                    onChange={handleCommentChange}
                                                />
                                            </Col>
                                        </FormGroup>

                                        <FormGroup>
                                            <Col smOffset={2} sm={10}>
                                                <Button bsStyle="primary" onClick={handleEditSave} style={{ marginRight: '10px' }}>
                                                    Save Changes
                                                </Button>
                                                <Button onClick={handleEditCancel}>
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    )}
                </Panel.Body>
            </Panel.Collapse>
        </Panel>
    )
}

export default EventHistoryAccordion;